import {validarCorreosReceptor} from '../../utils/correo.utils'
import {Dispatch} from 'react'
import {SUJETO_EXCLUIDO_TYPES} from '../../constants/sujetoExcluido.types'
import * as validacionesRegex from '../../utils/strings.utils'
import * as validators from '../../utils/validaciones'
import * as reg from '../../constants/Regex'
import {
getDepartamentos, getMunicipios, getTiposDocumento, setMunicipios,} from '../catalogos.actions'
import {State} from '../../reducers'
import {sujetoExcluidoInitialState} from '../../initital-state/sujetoExcluido.state'
import {sujetoExcluidoGetDatosEmisor} from './sujetoExcluidoEmision.actions'
import {SEClienteF, SujetoExcluidoAction} from '../../interfaces/sujeto-excluido.interface'
import {esNitDeSujetoExcluido, validarDistritoV2} from '../../utils/normativa.utils'
import {setDistritos} from '../catalogos.actions'

// ******************************************************************************************

export const sujetoExcluidoFormClienteHandleChange = (formCliente: SEClienteF) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMCLIENTE_HANDLE_CHANGE,
  payload: formCliente,
})

export const sujetoExcluidoFormClienteAddError = (formError: SEClienteF) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMCLIENTE_SET_ERRORS,
  payload: formError,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const sujetoExcluidoFormClienteHandleChangeInputPhone =
  (phone: string) =>
  async (dispatch: Dispatch<SujetoExcluidoAction>, getState: () => State) => {
    dispatch(sujetoExcluidoFormClienteHandleChange({telefono: phone}))
  }
export const sujetoExcluidoFormClienteHandleChangeInput =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
  async (dispatch: Dispatch<SujetoExcluidoAction>, getState: () => State) => {
    const {tipoDocumento} = getState().sujetoExcluido.formCliente
    let {name, value} = e.target
    switch (name) {
      case 'fecha':
        break
      case 'tipoDocumento':
        const tipoDoc = getState().catalogos.tipoDocumento.find((doc) => value === doc.codigo)
        dispatch(sujetoExcluidoFormClienteHandleChange({numId: ''}))
        dispatch(sujetoExcluidoFormClienteAddError({numId: ''}))
        if (tipoDoc)
          dispatch(sujetoExcluidoFormClienteHandleChange({nombreTipoDocumento: tipoDoc.valor}))
        else {
          dispatch(sujetoExcluidoFormClienteHandleChange({nombreTipoDocumento: ''}))
          dispatch(sujetoExcluidoFormClienteAddError(sujetoExcluidoInitialState.errorsFormCliente))
        }
        break
      case 'numId':
        if((tipoDocumento === "36" || tipoDocumento === "13") && !validacionesRegex.validarRegexNumericoInt(value) ) return
        if (!validacionesRegex.validarRegexNumIdentificacion(value)) return
        break
      case 'nombre':
        if (!validacionesRegex.validarRegexNombresCliente(value)) return
        break
      case 'departamento':
        const depto = getState().catalogos.departamentos.find((doc) => value === doc.codigo)
        if (depto)
          dispatch(sujetoExcluidoFormClienteHandleChange({nombreDepartamento: depto.valor}))
        else dispatch(sujetoExcluidoFormClienteHandleChange({nombreDepartamento: ''}))
        dispatch(sujetoExcluidoFormClienteHandleChange({municipio: '', distrito: '', nombreDistrito: '', direccion: ''}))
        dispatch(sujetoExcluidoFormClienteAddError({municipio: '', distrito: '', direccion: ''}))
        dispatch(setDistritos([]))
        break
      case 'municipio':
        dispatch(sujetoExcluidoFormClienteHandleChange({distrito: '', nombreDistrito: '', direccion: ''}))
        dispatch(sujetoExcluidoFormClienteAddError({distrito: '', direccion: ''}))
        break
      case 'distrito':
        const distritoElegido = getState().catalogos.distritos.find((doc) => value === doc.codigo)
        dispatch(sujetoExcluidoFormClienteHandleChange({nombreDistrito: distritoElegido ? distritoElegido.valor : ''}))
        break
      case 'direccion':
        if (!validacionesRegex.validarRegexLetras(value)) return
        break
      case 'email':
        if (!validacionesRegex.validarRegexLetras(value)) return
        break
      case 'telefono':
        if (!validacionesRegex.validarRegexLetras(value)) return
        break
      case 'condicion':
        break
      default:
        break
    }
    dispatch(sujetoExcluidoFormClienteHandleChange({[name]: value}))
  }

// ******************************************************************************************
// ? PETICIONES RES
// ******************************************************************************************
export const sujetoExcluidoConsultarCatalogos = () => async (dispatch: Dispatch<any>) => {
  try {
    Promise.all([
      dispatch(getDepartamentos()),
      dispatch(getTiposDocumento()),
      dispatch(sujetoExcluidoGetDatosEmisor()),
    ])
  } catch (error) {}
}

// ******************************************************************************************
// ? VALIDACIONES
// ******************************************************************************************
export const sujetoExcluidoFormClienteOnBlur =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
  async (dispatch: Dispatch<any>, getState: () => State) => {
    let {name, value} = e.target
    const {telefono, chipsEmail} = getState().sujetoExcluido.formCliente

    let message = ''
    switch (name) {
      case 'fecha':
        break
      case 'tipoDocumento':
        message = validators.validacionEsRequerido(value, message, 'Tipo Doc.')
        if (!value) {
          dispatch(
            sujetoExcluidoFormClienteHandleChange({...sujetoExcluidoInitialState.formCliente})
          )
        }
        break
      case 'numId':
        message = validators.validacionEsRequerido(
          value,
          message,
          getState().sujetoExcluido.formCliente.nombreTipoDocumento
        )
        if (!message) message = validators.validacionMinLenght(value, message, 3)
        if (!message && !esNitDeSujetoExcluido(getState().sujetoExcluido.formCliente.tipoDocumento))
          message = validators.validarTipoDocumento(
            getState().sujetoExcluido.formCliente.nombreTipoDocumento!,
            value,
            message
          )
        break
      case 'nombre':
        message = validators.validacionEsRequerido(value, message, 'Nombre')
        break
      case 'departamento':
        message = validators.validacionEsRequerido(value, message, 'Departamento')

        // Obtener el catálogo de municipio
        const depto = getState().sujetoExcluido.formCliente.nombreDepartamento
        if (depto) await dispatch(getMunicipios(Number(value), depto, true))
        else dispatch(setMunicipios([]))
        dispatch(
          sujetoExcluidoFormClienteHandleChange({
            municipio: '',
            nombreMunicipio: '',
          })
        )
        break
      case 'municipio':
        message = validators.validacionEsRequerido(value, message, 'Municipio')
        break
      case 'distrito':
        message = validarDistritoV2(getState().catalogos.datosEmisor, value) || message
        break
      case 'direccion':
        message = validators.validacionEsRequerido(value, message, 'Dirección')
        if (!message) message = validators.validacionMinLenght(value, message, 5)
        break
      case 'email':
        if (!chipsEmail?.length) {
          message = validators.validacionEmail(value, message, 'Correo electrónico')
        }
        if (!message) message = validarCorreosReceptor(value, chipsEmail)
        break
      case 'telefono':
        if(telefono) {
          if (!message) message = validators.validacionMinLenght(value, message, 8)
          if (!message) message = validators.validacionRegex(reg.REGEX_TELEFONO, value, message, 'Teléfono celular')
        }
        break
      case 'condicion':
        break
      default:
        break
    }
    dispatch(sujetoExcluidoFormClienteAddError({[name]: message}))
  }

export const sujetoExcluidoFormClienteValidacionesGenerarFactura = (
  dispatch: Dispatch<SujetoExcluidoAction>,
  getState: () => State
) => {
  const {formCliente, errorsFormCliente} = getState().sujetoExcluido

  errorsFormCliente.tipoDocumento = validators.validacionEsRequerido(formCliente.tipoDocumento!,errorsFormCliente.tipoDocumento!,'Tipo Doc.')

  errorsFormCliente.numId = validators.validacionEsRequerido(formCliente.numId!,errorsFormCliente.numId!,getState().sujetoExcluido.formCliente.nombreTipoDocumento)
  if (!errorsFormCliente.numId) errorsFormCliente.numId = validators.validacionMinLenght( formCliente.numId!, errorsFormCliente.numId, 3)
  if (!errorsFormCliente.numId && !esNitDeSujetoExcluido(formCliente.tipoDocumento)) errorsFormCliente.numId = validators.validarTipoDocumento(getState().sujetoExcluido.formCliente.nombreTipoDocumento!,formCliente.numId!,errorsFormCliente.numId)

  errorsFormCliente.nombre = validators.validacionEsRequerido(formCliente.nombre!,errorsFormCliente.nombre!,'Nombre')

  errorsFormCliente.departamento = validators.validacionEsRequerido(formCliente.departamento!,errorsFormCliente.departamento!,'Departamento')

  errorsFormCliente.municipio = validators.validacionEsRequerido(formCliente.municipio!,errorsFormCliente.municipio!,'Municipio')

  errorsFormCliente.distrito = validarDistritoV2(
    getState().catalogos.datosEmisor,
    formCliente.distrito
  )

  errorsFormCliente.direccion = validators.validacionEsRequerido(formCliente.direccion!,errorsFormCliente.direccion!,'Dirección')
  if (!errorsFormCliente.direccion) errorsFormCliente.direccion = validators.validacionMinLenght(formCliente.direccion!,errorsFormCliente.direccion!,5)

  if (!formCliente.chipsEmail?.length) {
    errorsFormCliente.email = validators.validacionEsRequerido(
      formCliente.email!,
      errorsFormCliente.email!,
      'Correo electrónico'
    )
  }
  
  if (!errorsFormCliente.email) {
    errorsFormCliente.email = validarCorreosReceptor(formCliente.email, formCliente.chipsEmail)
  }

  if(formCliente.telefono) {
    errorsFormCliente.telefono = validators.validacionMinLenght(formCliente.telefono!,errorsFormCliente.telefono!,8)
    if (!errorsFormCliente.telefono) errorsFormCliente.telefono = validators.validacionRegex(reg.REGEX_TELEFONO, formCliente.telefono!,errorsFormCliente.telefono!,'Teléfono celular')
  }

  dispatch(sujetoExcluidoFormClienteAddError(errorsFormCliente))

  const hasErrors = Object.values(errorsFormCliente).some(error => error);
  if (hasErrors) return true;
  return false
}
